import * as React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { observer } from "mobx-react";
import AdminLayout from "./Layout/AdminLayout";
import DashboardPage from "../pages/DashboardPage";
import ActivityLogPage from "../pages/ActivityLogPage";
import UsersPage from "../pages/UsersPage";
import CategoriesPage from "../pages/CategoriesPage";
import CountriesPage from "../pages/CountriesPage";
import PackagesPage from "../pages/PackagesPage";
import AccountApprovalsPage from "../pages/AccountApprovalsPage";
import PaymentSubscriptionsPage from "../pages/PaymentSubscriptionsPage";
import AdvertisementsManagement from "../pages/admin/AdvertisementsManagement";
import AdvertisementStatistics from "../pages/admin/AdvertisementStatistics";
import ServicesManagement from "../pages/admin/ServicesManagement";
import SubscriptionsManagement from "../pages/admin/Subscriptions";
import ImportServices from "../pages/admin/ImportServices";
import store from "../Store";

export interface IWebAppProps {}

export interface IWebAppState {
  pageName: string;
}

class WebApp extends React.Component<IWebAppProps, IWebAppState> {
  constructor(props: IWebAppProps) {
    super(props);

    this.state = {
      pageName: "Home",
    };
  }

  componentDidMount() {
    console.log('WebApp: Checking authentication...');
    console.log('WebApp: Store isAuthenticated:', store.isAuthenticated);
    
    // التحقق من حالة المصادقة باستخدام Store بدلاً من Cookies مباشرة
    if (!store.isAuthenticated) {
      // التحقق من localStorage أيضاً
      const token = localStorage.getItem('admin_token');
      console.log('WebApp: Token in localStorage:', !!token);
      if (!token) {
        console.log('WebApp: No token found, redirecting to login');
        globalThis.location.href = "/login";
        return;
      }
    }
    console.log('WebApp: Authentication check passed');
  }

  public render() {
    console.log('WebApp: Rendering WebApp component');
    return (
      <AdminLayout>
        <Routes>
          <Route path="/" element={<Navigate to="/admin/dashboard" replace />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/activity-log" element={<ActivityLogPage />} />
          <Route path="/users" element={<UsersPage />} />
          <Route path="/categories" element={<CategoriesPage />} />
          <Route path="/countryManager" element={<CountriesPage />} />
          <Route path="/packages" element={<PackagesPage />} />
          <Route path="/account-approvals" element={<AccountApprovalsPage />} />
          <Route path="/payment-subscriptions" element={<PaymentSubscriptionsPage />} />
          <Route path="/advertisements" element={<AdvertisementsManagement />} />
          <Route path="/advertisement-statistics" element={<AdvertisementStatistics />} />
          <Route path="/services" element={<ServicesManagement />} />
          <Route path="/import-services" element={<ImportServices />} />
          <Route path="/Subscriptions" element={<SubscriptionsManagement />} />
          <Route path="*" element={<Navigate to="/admin/dashboard" replace />} />
        </Routes>
      </AdminLayout>
    );
  }
}

export default observer(WebApp);
